
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class DebugConsoleEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.fillStyle = pc.color;
        ctx.font = `${11 * scale}px monospace`;

        const logs = [
            "INIT_CORE... OK",
            "REDUNDANCY_CHECK: FAILED",
            "OVERRIDING_SENSORS...",
            "BUFFER_OVERFLOW_DETECTED",
            "EXECUTING_DEBUG_STUB",
            "LINK_ESTABLISHED: 0xFF21",
            "UPLINK_STABLE"
        ];

        const draw = () => {
             ctx.save();
             ctx.translate(-width + 50 * scale, -height + 50 * scale);
             ctx.globalAlpha *= 0.6 / layerIndex;
             
             const totalLines = 15;
             for (let i = 0; i < totalLines; i++) {
                 const logIdx = Math.floor(this.pseudoRandom(i + Math.floor(curTime * 2)) * logs.length);
                 const y = i * 20 * scale;
                 ctx.fillText(`> ${logs[logIdx]}`, 0, y);
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
